import { buildSiteHref, getSiteHomeHref, isPublicAuthPath } from '@/lib/site-paths';

export function resolveAuthRedirectTarget(redirect: unknown, fallback = getSiteHomeHref()): string {
  if (typeof redirect !== 'string') {
    return fallback;
  }

  const trimmed = redirect.trim();
  if (!trimmed) {
    return fallback;
  }

  try {
    const url = new URL(trimmed, window.location.origin);
    if (url.origin !== window.location.origin) {
      return fallback;
    }

    if (isPublicAuthPath(url.pathname)) {
      return fallback;
    }

    return `${url.pathname}${url.search}${url.hash}` || fallback;
  } catch {
    return fallback;
  }
}

export function buildLoginRedirectHref(currentHref: string): string {
  const homeHref = getSiteHomeHref();
  const loginUrl = new URL(buildSiteHref('/login'), window.location.origin);
  const safeRedirectTarget = resolveAuthRedirectTarget(currentHref, homeHref);

  if (safeRedirectTarget !== homeHref) {
    loginUrl.searchParams.set('redirect', safeRedirectTarget);
  }

  return `${loginUrl.pathname}${loginUrl.search}${loginUrl.hash}`;
}
